import styled, { css } from 'styled-components';

export const TruckerSummaryWrapper = styled.div`
  ${({ theme }) => css`
    width: 100%;
    position: absolute;
    z-index: ${theme.zIndex.modal};
    top: ${theme.spacing.km14};
  `}
`;

export const ContentWrapper = styled.div`
  padding: ${({ theme }) => theme.spacing.km4};
  min-height: 257px;
`;
